import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { Section } from "../../../models/Section";

type Props = {
	onSelectSection: (section: Section, modal: "update" | "delete") => void;
	handleNewSection: () => void;
};
export const useSectionOptionsFunctions = ({
	onSelectSection,
	handleNewSection,
}: Props) => {
	const getMenuOptions = (data: Section) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Section",
				key: "new_section",
				onClick: () => {
					handleNewSection();
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Section",
					key: "edit_section",
					onClick: () => {
						onSelectSection(data, "update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Section",
					key: "delete_section",
					onClick: () => {
						onSelectSection(data, "delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
